import { statsColumnsMapping } from './stats';

export const qualityMultipliers = {
    5: 2,
    4: 1.75,
    3: 1.5,
    2: 1.3,
    1: 1.15,
    0: 1,
};

export const calculateItemStats = (prefixId, base, suffixId, quality = 0) => {
    console.log('Calculating item stats with:', { prefixId, base, suffixId, quality });
    
    const baseStats = window.charPlannerData.baseStats;
    const prefixesStats = window.charPlannerData.prefixesStats;
    const suffixesStats = window.charPlannerData.suffixesStats;

    // Initialize stats array with zeros
    const stats = Array(22).fill(0);
    
    // Get base stats
    const [category] = base.split('-');
    const categoryStats = baseStats[category];
    const baseStat = categoryStats ? categoryStats[base] : null;
    
    if (!baseStat) {
        console.log('No base stats found for:', base);
        return { stats };
    }
    console.log('Base stats:', baseStat);

    // Add base stats to stats array
    for (let k = 0; k < stats.length; k++) {
        stats[k] += parseInt(baseStat[k] || 0);
    }

    // Add prefix and suffix stats
    for (let k = 0; k < stats.length; k++) {
        if (prefixId) {
            const prefix = prefixesStats.find(p => p.id === parseInt(prefixId));
            if (prefix && prefix.stats) {
                stats[k] += Math.floor(parseInt(prefix.stats[k] || 0) * (k < 21 ? qualityMultipliers[quality] : 1));
            }
        }

        if (suffixId) {
            const suffix = suffixesStats.find(s => s.id === parseInt(suffixId));
            if (suffix && suffix.stats) {
                stats[k] += Math.floor(parseInt(suffix.stats[k] || 0) * (k < 21 ? qualityMultipliers[quality] : 1));
            }
        }
    }

    let baseLevel = baseStat[0];
    let itemLevel = stats[statsColumnsMapping.level] + baseLevel;
    
    // Add base level to total level
    stats[statsColumnsMapping.level] += baseLevel;

    const generatedItem = { stats };
    generatedItem.isWeapon = base.match(/^1-/);
    generatedItem.isArmor = base.match(/^[23458]-/);

    // For weapons, calculate low and high damage
    if (generatedItem.isWeapon) {
        let baseLowDamage = baseStat[1];
        let baseHiDamage = baseStat[2];
        let prefixDamage = prefixId ? (prefixesStats.find(p => p.id === parseInt(prefixId))?.stats?.[statsColumnsMapping.damage] || 0) : 0;
        let suffixDamage = suffixId ? (suffixesStats.find(s => s.id === parseInt(suffixId))?.stats?.[statsColumnsMapping.damage] || 0) : 0;
        
        let damageLow = Math.ceil((itemLevel - baseLevel + 1) * 1.2) + baseLowDamage + 2 * (prefixDamage + suffixDamage) - 2;
        let damageHigh = Math.ceil((itemLevel - baseLevel + 1) * 1.5) + baseHiDamage + 2 * (prefixDamage + suffixDamage) - 2;
        
        generatedItem.damageLow = Math.floor((damageLow > 0 ? damageLow : 1) * qualityMultipliers[quality]); // Min-cap low damage to 1
        generatedItem.damageHigh = Math.floor(damageHigh * qualityMultipliers[quality]);
        console.log('Weapon damage calculated:', { damageLow: generatedItem.damageLow, damageHigh: generatedItem.damageHigh });
    }

    // For armor items, calculate armor based on level
    if (generatedItem.isArmor) {
        const armorType = base.match(/^[23458]/)[0];
        const armorFactors = {
            '2': [10, 20],
            '3': [10, 20],
            '4': [5, 40],
            '5': [3, 100 / 1.5],
            '8': [6, 100 / 3]
        };
        const [f1, f2] = armorFactors[armorType];
        stats[statsColumnsMapping.armor] += Math.floor(Math.floor(((itemLevel - baseLevel)) * (f1 + ((itemLevel - baseLevel)) / f2)));
        console.log('Armor calculated:', stats[statsColumnsMapping.armor]);
    }

    // Apply quality multiplier to armor
    stats[statsColumnsMapping.armor] = Math.floor(stats[statsColumnsMapping.armor] * qualityMultipliers[quality]);

    // Special cases for different item types
    if (base.match(/^2/)) { // Shield
        stats[statsColumnsMapping.charismaPercentage] = 0;
    }
    if (base.match(/^3/)) { // Chest armor
        stats[statsColumnsMapping.agilityPercentage] = 0;
    }
    if (base.match(/^8/)) { // Shoes
        stats[statsColumnsMapping.dexterityPercentage] = 0;
    }
    if (base.match(/^[69]/)) { // Jewelery
        stats[statsColumnsMapping.strengthPercentage] = 0;
    }

    console.log('Final generated item:', generatedItem);
    return generatedItem;
}; 